import { Container } from "@mui/system";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FaqIcon, LogoutIcon, SupportIcon } from "assets/images";
import styles from "./Aside.module.css";
import navLinks from "utils/navLinks";
import AppBackdrop from "component/appBackdrop/AppBackdrop";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";
import { AuthContext } from "context/AuthContext";
import { useLogout } from "api/mutations/auth";


function Aside({ activeTab }) {
  const {logOut, loading} = useLogout()

  const { signOut } = useContext(AuthContext);
  const [openPrompt, setOpenPrompt] = useState(false);
  return (
    <aside className={`${styles.aside} ${styles.scrollbar_hidden}`}>
      <Container>
        <div className={styles.aside_content}>
          {navLinks.map((link) => (
            <Link
              key={link?.name}
              className={activeTab === link?.name ? styles.active_link : null}
              to={link?.url}
            >
              {activeTab === link?.name ? link?.activeIcon : link?.icon}
              {link?.name}
            </Link>
          ))}
          {/* ======== SUPPORT LINK ======== */}
          {/* <a href="mailto:homeloansunit@stanbicibtc.com">
            <SupportIcon color={activeTab === "support" && "#0a2240"} /> contact
            us
          </a> */}
          <Link
          
            className={activeTab === "faq" ? styles.active_link : null}
            to={"/faq"}
          >
            <FaqIcon color={activeTab === "faq" ? "#0072CE" : ""} />
            FAQs
          </Link>
          {/* ======== LOGOUT BUTTON ======== */}
          <Link
            onClick={(e) => {
              e.preventDefault();
              setOpenPrompt(true);
              //logOut();
            }}
            className={activeTab === "logout" ? styles.active_link : null}
            to={""}
          >
            <LogoutIcon color={activeTab === "logout" ? "#0072CE" : ""} />
            logout
          </Link>
        </div>
      </Container>
      <AppBackdrop
        openModal={openPrompt}
        handleCloseModal={() => {
          setOpenPrompt(false);
        }}
        children={
          <AuthModalLayout
        
            secondaryBtn
            handleClickSecondaryBtn={() => {
              setOpenPrompt(false);
            }}
            handleClose={() => {
              logOut();
            }}
            loading={loading}
            icon={'info'}
            btnText="Log out"
            primaryText="Log out"
            secondaryText="You are about to log out of the app"
          />
        }
      />
    </aside>
  );
}

export default Aside;